<template>
  <section class="section container pt-0">
    <task-datatable :module_settings="module_settings" />
  </section>
</template>

<script>
import { get_configuration, error_message } from "@/utils";
import TaskDatatable from "./task_datatable/Index.vue";

export default {
  name: "TaskIndex",
  components: { TaskDatatable },
  data() {
    return {
      module_settings: {},
    };
  },
  created() {
    let v = this;
    get_configuration(this)
      .then((conf) => {
        v.module_settings = conf;
      })
      .catch((error) => {
        error_message(error);
      });
  },
};
</script>

<style scoped></style>
